import { create } from './dom';
import isEmpty from 'lodash/isEmpty';

/**
 * This import of 'swiper.css' was moved from beeing loaded dynamically with
 * the swiper js to here because of a graphical glitch that was caused when the
 * css was slow to load.
 */
import 'swiper/dist/css/swiper.css';

export const SWIPER_CONTAINER_CLASS_NAME = 'swiper-container';
export const SWIPER_WRAPPER_CLASS_NAME = 'swiper-wrapper';
export const SWIPER_SLIDE_CLASS_NAME = 'swiper-slide';
export const SWIPER_SLIDE_LAZY_PRELOADER = 'swiper-lazy-preloader';
export const SWIPER_NAVIGATION_PREV_CLASS_NAME = 'swiper-button-prev';
export const SWIPER_NAVIGATION_NEXT_CLASS_NAME = 'swiper-button-next';

/**
 * Imports dynamically Swiper library dependencies
 * @see https://webpack.js.org/guides/code-splitting/#dynamic-imports
 * @returns {Swiper}   Swiper module
 */
const importSwiperModule = async () => {
    const { default: Swiper } = await import(
        /* webpackChunkName: "swiper-module" */ '../../legacy/modules/swiper'
    );

    return Swiper;
};

export const createSwiper = (
    containerElement,
    wrapperElement,
    options = {},
    gtmAttribute = '',
    customNav = false
) => {
    const swiperOptions = {...options};

    wrapperElement.children.forEach((elem) => {
        elem.classList.add(SWIPER_SLIDE_CLASS_NAME);

        if (!isEmpty(swiperOptions) && swiperOptions.lazy) {
            let lazyPreLoader = create('div', SWIPER_SLIDE_LAZY_PRELOADER);
            wrapperElement.firstChild.appendChild(lazyPreLoader);
        }
    });

    if (swiperOptions.navigation && !customNav) {
        // To keep the options passed to this utility the same as you would pass to the Swiper
        // function.
        swiperOptions.navigation = {
            ...swiperOptions.navigation,
            prevEl: swiperOptions.navigation.prevEl.replace('.', ''),
            nextEl: swiperOptions.navigation.nextEl.replace('.', ''),
        };

        const prevEl = create('div', `${SWIPER_NAVIGATION_PREV_CLASS_NAME} ${swiperOptions.navigation.prevEl}`);
        const nextEl = create('div', `${SWIPER_NAVIGATION_NEXT_CLASS_NAME} ${swiperOptions.navigation.nextEl}`);

        containerElement.appendChild(prevEl);
        containerElement.appendChild(nextEl);

        swiperOptions.navigation = {
            prevEl,
            nextEl,
        };
    }

    if (gtmAttribute !== '') {
        containerElement.setAttribute('data-spectate-product', gtmAttribute);
    }

    return importSwiperModule()
        .then(Swiper => new Swiper(containerElement, swiperOptions).on('slideChange', function () {
            window.dataLayer.push({
                'event': 'SP_SWIPE', 'gtm.element': containerElement});
            }));
    };
